import { Link } from 'react-router-dom';

const steps = [
  {
    step: '01',
    title: 'Search Category',
    desc: 'Browse through 14 product categories with verified supplier data and curated listings.',
    icon: 'ri-search-line',
  },
  {
    step: '02',
    title: 'Compare Suppliers',
    desc: 'Evaluate pricing, shipping data, and supplier ratings side-by-side in structured format.',
    icon: 'ri-scales-3-line',
  },
  {
    step: '03',
    title: 'Buy with Confidence',
    desc: 'Select verified sellers and redirect to purchase with reduced sourcing risk.',
    icon: 'ri-shopping-bag-3-line',
  },
];

export default function HowItWorks() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50" id="how-it-works">
      <div className="mb-12 md:mb-16">
        <p className="text-xs tracking-[0.2em] uppercase text-accent-600 font-medium mb-2">
          / Process
        </p>
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-[1.05]">
          How It<br />Works
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {steps.map((s, index) => {
          const images = [
            'https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20organized%20product%20catalog%20grid%20on%20screen%20surrounded%20by%20fashion%20items%20and%20coffee%20cup%20on%20light%20oak%20desk%20bright%20natural%20window%20light%20clean%20aesthetic%20productive%20atmosphere%20editorial%20style&width=800&height=700&seq=how-step1-v4&orientation=landscape',
            'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20view%20on%20monitor%20showing%20product%20data%20charts%20and%20pricing%20tables%20with%20fashion%20accessories%20arranged%20in%20foreground%20on%20white%20desk%20modern%20office%20setting%20with%20plants%20and%20natural%20daylight%20analytical%20mood%20editorial%20photography&width=800&height=700&seq=how-step2-v4&orientation=landscape',
            'https://readdy.ai/api/search-image?query=Shopping%20bag%20filled%20with%20wrapped%20fashion%20purchases%20on%20wooden%20bench%20near%20large%20window%20with%20city%20view%20warm%20afternoon%20light%20confident%20joyful%20atmosphere%20editorial%20lifestyle%20photography%20commercial%20success%20feeling%20clean%20composition&width=800&height=700&seq=how-step3-v4&orientation=landscape',
          ];
          return (
            <div
              key={s.step}
              className="rounded-2xl border border-background-200 overflow-hidden bg-background-50 group hover:border-accent-300 transition-colors duration-300"
            >
              <div className="h-56 md:h-64 bg-background-100 flex items-center justify-center p-6 relative overflow-hidden">
                <img
                  src={images[index]}
                  alt={`Step ${s.step}: ${s.title} - itaobuyspreadsheet process`}
                  title={`itaobuyspreadsheet - ${s.title}`}
                  className="w-full h-full object-cover object-top rounded-lg"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-2xl md:text-3xl font-heading font-bold text-accent-500">{s.step}</span>
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900">{s.title}</h3>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">{s.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}